/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Column_WpmInputs */



/**
* | output |
* | --- |
* | "WPM" |
*
* @param {Editor_Table_Column_WpmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_column_wpm = /** @type {((inputs?: Editor_Table_Column_WpmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Column_WpmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("MPM")
	if (locale === "de") return /** @type {LocalizedString} */ ("WPM")
	if (locale === "it") return /** @type {LocalizedString} */ ("WPM")
	if (locale === "ru") return /** @type {LocalizedString} */ ("слов в минуту")
	if (locale === "es") return /** @type {LocalizedString} */ ("PPM")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每分钟字数")
	if (locale === "ja") return /** @type {LocalizedString} */ ("WPM")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डब्ल्यूपीएम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Palavras por minuto")
	return /** @type {LocalizedString} */ ("WPM")
});